module.exports = __webpack_public_path__ + "static/media/bch.52f348b2.svg";